import React, { useContext, useState } from "react";
import style from "./index.module.scss";
import CourseHeader from "../../../components/CourseHeader";
import { Breadcrumb, Button, Spin } from "antd";
import DetailLayout from "../../../components/DetailLayout";
import { useHistory, useParams } from "react-router-dom";
import Mark from "./Components/Mark";
import useRequest from "utils/useRequest";
import { getGroupActivityTaskHomeworkForCheck } from "../../../../../service/group";
import moment from "moment";
import Answer from "./Components/Answer";
import { useAtomValue } from "jotai";
import { joinedStudentsAtom } from "../../store";
import { CourseContext } from "../../../Store";

export default function ReviewPage() {
    const history = useHistory();
    const { basename } = useContext(CourseContext);
    const { activityId, taskId, groupId, statusId, homeworkId } = useParams();
    const staticsList = useAtomValue(joinedStudentsAtom);

    const [loadingState, setLoadingState] = useState(true); //默认为ture，当修改评分或评语后改值为false

    const currentIndex =
        staticsList?.findIndex(
            item => item.homeworkId === Number(homeworkId)
        ) || 0;

    const [data, { loading }, refreshData] = useRequest(
        () =>
            getGroupActivityTaskHomeworkForCheck({
                activityId,
                taskId,
                groupId,
                statusId,
                homeworkId
            }),
        {},
        [activityId, taskId, groupId, statusId, homeworkId]
    );

    //上一步
    function goPrev() {
        const next = staticsList?.[currentIndex - 1];
        if (!next) return;
        history.replace(
            `${basename}/group/detail/${next.activityId}/review/${next.taskId}/${next.groupId}/${next.statusId}/${next.homeworkId}`
        );
    }

    //下一步
    function goNext() {
        const next = staticsList?.[currentIndex + 1];
        if (!next) return;
        history.replace(
            `${basename}/group/detail/${next.activityId}/review/${next.taskId}/${next.groupId}/${next.statusId}/${next.homeworkId}`
        );
    }

    async function onOk() {
        await setLoadingState(false);
        await refreshData();
    }

    const breadcrumb = (
        <>
            <Breadcrumb.Item onClick={() => history.goBack()}>
                <a>小组详情</a>
            </Breadcrumb.Item>
            <Breadcrumb.Item>批阅作业</Breadcrumb.Item>
        </>
    );
    return (
        <DetailLayout breadcrumb={breadcrumb}>
            <CourseHeader
                title={data?.group.groupName || ""}
                info={
                    <div className={style.info}>
                        提交时间：
                        {data?.group.createTime
                            ? moment(data?.group.createTime).format(
                                  "YYYY-MM-DD HH:mm:ss"
                              )
                            : "--"}
                    </div>
                }
                extra={
                    <div className={style.btns}>
                        {currentIndex !== 0 && (
                            <Button type="primary" onClick={goPrev}>
                                上一份
                            </Button>
                        )}

                        {staticsList &&
                            currentIndex !== staticsList.length - 1 && (
                                <Button type="primary" onClick={goNext}>
                                    下一份
                                </Button>
                            )}
                    </div>
                }
            />

            <Spin spinning={loading && loadingState}>
                <div className={style.root}>
                    <div className={style.info}>
                        <Answer task={data?.task} homework={data?.homework} />
                    </div>
                    <div className={style.edit}>
                        <Mark
                            homework={data?.homework}
                            totalScore={data?.task.score}
                            memberGrade={data?.memberGrade || []}
                            refreshData={onOk}
                            loading={loading}
                        />
                    </div>
                </div>
            </Spin>
        </DetailLayout>
    );
}
